import { Directive, HostListener, Input } from '@angular/core';
import { DataAnalyticsTaggingEvent } from './data-analytics-tagging.domain';
import { DataAnalyticsTaggingConstants } from './data-analytics-tagging.constants';
import { DataAnalyticsTaggingService } from './data-analytics-tagging.service';

@Directive({
  selector: '[tdWbDataAnalyticsTaggingInput]'

})

export class DataAnalyticsTaggingInputDirective {

  constructor(
    private dataAnalyticsTaggingService: DataAnalyticsTaggingService
  ) {}

  @Input('eventInput') dataAnalyticsTaggingEvent: DataAnalyticsTaggingEvent;

  @Input('sliderSection') sliderSection: string;

  // For events whose property/attribute values are unknown until runtime
  // Only executes when Parent component set 'delayed' to 'false'
  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    const target = event.target as HTMLElement | null;
    let targetIcon: HTMLElement = target?.querySelector('.td-wb-icon');
    if ((targetIcon == null)){
      targetIcon = target;
    }
    const iconEle: Attr = targetIcon.attributes.getNamedItem('iconid');
    const iconId = iconEle?.value;
    let eventName;
    if (iconId){
      switch(iconId){
        case 'caret-left--small':
          eventName = `tdw:wbt:learn:${this.sliderSection}:prev`;
          break;
        case 'caret-right--small':
          eventName = `tdw:wbt:learn:${this.sliderSection}:next`;
          break;
        default:
          eventName = this.dataAnalyticsTaggingEvent.link?.name;
          break;
      }
    } else {
      eventName = this.dataAnalyticsTaggingEvent.link?.name;
    }
    if (eventName){
      if (this.dataAnalyticsTaggingEvent?.link?.type){
        this.dataAnalyticsTaggingService.emitTaggingEvent(DataAnalyticsTaggingConstants.getLinkClickEventData(eventName, this.dataAnalyticsTaggingEvent.link.type));
      } else {
        this.dataAnalyticsTaggingService.emitTaggingEvent(DataAnalyticsTaggingConstants.getLinkClickEventData(eventName));
      }
    }
  }
}
